export class FloorPlanStep
{
    updatedGeoRefBefore;
    updatedGeoRefAfter;
    constructor(obj)
    {
        Object.assign(this, obj);
    }
}
